module.exports = __webpack_public_path__ + "img/产品展示.5295ed8b.png";